export default {
  PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES : 'informationsgenerales',
  PAGE_NEOPASS_FORM_SITUATION_PERSONNELLE : 'situationpersonnelle',
  PAGE_NEOPASS_FORM_SITUATION_PROFESSIONNELLE : 'situationprofessionnelle',
  PAGE_NEOPASS_FORM_PARCOURS : 'parcours',
  PAGE_NEOPASS_FORM_PORTFOLIO : 'portfolio',

  PAGE_NEOPASS_FORM_ACTIVITES_EXTRA_PRO : 'extrapro',
  PAGE_NEOPASS_FORM_COMPETENCES_CLES : 'compcle',
  PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE : 'informatique',
  PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES : 'langue',

  PAGE_NEOPASS_FORM_APTITUDES_PERSONNELLES : 'aptitudes_perso',
  PAGE_NEOPASS_FORM_COMPORTEMENT_SOCIAL_RELATIONNEL : 'comportement_social',
  PAGE_NEOPASS_FORM_APTITUDES_TRAVAIL : 'aptitudes_pro',
  PAGE_NEOPASS_FORM_PRODUCTIVITE_TECHNICITE : 'productivite',
  PAGE_NEOPASS_FORM_ATTITUDES_TRAVAIL : 'attitudes_pro',
  PAGE_NEOPASS_FORM_RAPPORT_REGLES_CONTRAINTES : 'regles',

  PAGE_NEOPASS_FORM_POSTE_1 : 'p1',
  PAGE_NEOPASS_FORM_POSTE_2 : 'p2',
  PAGE_NEOPASS_FORM_POSTE_3 : 'p3',
  PAGE_NEOPASS_FORM_POSTE_4 : 'p4',
  PAGE_NEOPASS_FORM_POSTE_5 : 'p5',

  PAGE_NEOPASS_FORM_FORMATION_1 : 'f1',
  PAGE_NEOPASS_FORM_FORMATION_2 : 'f2',
  PAGE_NEOPASS_FORM_FORMATION_3 : 'f3',
  PAGE_NEOPASS_FORM_FORMATION_4 : 'f4',
  PAGE_NEOPASS_FORM_FORMATION_5 : 'f5',

  PAGE_NEOPASS_FORM_BILANS : 'bilans',
  PAGE_NEOPASS_FORM_PROJETS : 'projets',

  PAGE_NEOPASS_FORM_ACCESSIBILITE : 'accessibilite',
  PAGE_NEOPASS_FORM_POSTE_DE_TRAVAIL : 'poste',
  PAGE_NEOPASS_FORM_AUTONOMIE : 'autonomie',

  PAGE_NEOPASS_FORM_DOCUMENTS : 'documents',

  PAGE_NEOPASS_FORM_COMPTE_RENDU: 'compterendu',

  PAGE_FICHE_DE_POSTE : 'job_desc',
  PAGE_REFERENTIEL_FORMATION : 'ref_formation',

  PAGE_CARTOGRAPHIE_COMPETENCES_PERSO : 'competencesperso',
  PAGE_CARTOGRAPHIE_COMPETENCES_SOCIO_PRO : 'competencessociopro',
  PAGE_CARTOGRAPHIE_COMPETENCES_PRO : 'competencespro',
  PAGE_CARTOGRAPHIE_COMPETENCES_SCOLAIRES : 'competencessco',

  PAGE_CARTOGRAPHIE_COLLECTIVE_INFORMATIONS: 'informations',
  PAGE_CARTOGRAPHIE_COLLECTIVE_STAGES_FORMATIONS: 'cartographiesstagesformations',
  PAGE_CARTOGRAPHIE_COLLECTIVE_COMPETENCES_CLES: 'cartographiescompetencescles',
  PAGE_CARTOGRAPHIE_COLLECTIVE_POSTES: 'cartographiespostes',
  PAGE_CARTOGRAPHIE_COLLECTIVE_PLAN_ACCOMPAGNEMENT: 'cartographiesplan',
};